module.exports = __webpack_public_path__ + "static/media/noTransaction.53ffaf6c.svg";